<template>
  <div
    class="sy-preview"
    v-if="visible"
  >
    <!-- 遮罩层 -->
    <div class="sy-image-viewer__mask"></div>
    <!-- 头部 -->
    <div class="header">
      <div class="file-title">{{imgItem.name}}</div>
      <i
        class="el-icon-circle-close"
        @click="close()">
      </i>
      <i v-if="isCanDownload"
        class="el-icon-download"
        @click="downloadClick()">
      </i>
    </div>
    <!-- 文件预览区域 -->
    <div
      class="sy-image-viewer__canvas">
      <div
        v-for="(item, i) in imgBlobList"
        :key="item">
        <template
          v-if="i === index">
          <template
            v-if="accept.indexOf(imgItem.type) > -1">
            <img
              v-if="imgItem.type !== 'pdf'"
              :style="imgStyle"
              :src="imgItem.src"
              @error="handleImgError"
              @mousedown="handleMouseDown">
            <embed v-else :src="imgItem.src" type="application/pdf" :style="`position:fixed;top:72px;left:0;right:0;bottom:0;${unLoad ? 'z-index:-1' : ''}`" width="100%" height="100%">
          </template>
        </template>
      </div>
      <div
        v-show="accept.indexOf(imgItem.type) === -1 || unLoad"
        class="not-support__wapper">
        <span class="link-box">
          <i class="el-icon-link"></i>
        </span>
        <p class="text mt-10">我们不能预览该文件。</p>
        <p v-if="isCanDownload" class="text">您要先下载文件以查看。</p>
        <el-button v-if="isCanDownload" class="mt-10" @click="downloadClick()" plain>下载</el-button>
      </div>
    </div>
    <!-- 切换 上一个 下一个 -->
    <span
      class="image-viewer__btn image-viewer__prev"
      @click="prev">
      <i class="el-icon-arrow-left"></i>
    </span>
    <span
      class="image-viewer__btn image-viewer__next"
      @click="next">
      <i class="el-icon-arrow-right"></i>
    </span>
    <!-- 放大缩小旋转 -->
    <div
      class="image-viewer__btn sy-image-viewer__actions"
      v-if="imgItem.type !== 'pdf'">
      <div class="sy-image-viewer__actions__inner">
        <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
        <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
        <i :class="mode.icon" @click="toggleMode"></i>
        <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
        <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
      </div>
    </div>
  </div>
</template>

<script>
import download from '../../../utils/download'
import { PDFDocument, rgb, degrees } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
const Accept = ['jpg', 'png', 'pdf'] //后端支持的文件类型枚举
const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
}
const defaultApi = { //附件预览内置api
  downloadApi: {
    url: `/${window.fe.project}/upload/download`, // window.fe.project == `purchaser`
    type: 'get' // type
  },
  previewApi: { //预览api
    url: `/${window.fe.project}/file/preview`, // url
    type: 'post', // type
    extraParams: {
      'fileReviewBusinessCode': 'DEMO',
      'bizCode': null
    }
  }
}
const isServer = window.fe.vue.prototype.$isServer
function rafThrottle (fn) {
  let locked = false
  return function (...args) {
    if (locked) return
    locked = true
    window.requestAnimationFrame(_ => {
      fn.apply(this, args)
      locked = false
    })
  }
}
const on = (function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()
const off = (function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()
export default {
  name: 'preview',
  data () {
    return {
      visible: false,
      fileList: [],
      imgBlobList: [],
      imgItem: {
        'src': null,
        'type': '',
        'name': '',
        'raw': null,
        'key': ''
      },
      index: 0,
      mode: Mode.CONTAIN,
      accept: Accept,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      },
      unLoad: false //后端给了空响应
    }
  },
  props: {
    prop: {
      type: Object,
      default: {
        prewKey: 'url',
        name: 'name', //文件名称
        url: 'url' //文件下载接口的url参数取值字段
      }
    },
    previewExtraParams: { //预览接口额外参数
      type: Object,
      default: defaultApi.previewApi.extraParams
    },
    downloadApi: { //下载api
      type: Object,
      default: defaultApi.downloadApi
    },
    previewApi: { //预览api
      type: Object,
      default: defaultApi.previewApi
    },
    previewDownLoad: { //是否启用预览附件组件的下载方式 默认启用
      type: Boolean,
      default: true
    },
    isCanDownload: { //是否支持下载
      type: Boolean,
      default: true
    },
    watermarkText: { // 水印文案，默认不展示水印
      type: String,
      default: ''
    }
  },
  computed: {
    imgStyle () {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      }
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%'
      }
      return style
    }
  },
  methods: {
    // 关闭弹窗
    close () {
      this.visible = false
    },
    // 预览
    preview (file, fileList) {
      this.fileList = fileList
      this.imgBlobList = []
      this.imgItemReset()
      this.setPreviewData(file, fileList)
      this.visible = true
    },
    // 组装预览的数据
    setPreviewData (file, fileList) {
      fileList.forEach((element, i) => {
        // let nameIndex = element[this.prop.name].split('.')
        // console.log(nameIndex)
        // let type = nameIndex[nameIndex.length - 1]
        let subIndex = element[this.prop.name].lastIndexOf('.') + 1 // 查找文件后缀
        let fileType = element[this.prop.name].substring(subIndex).toLocaleLowerCase() // 获取文件后缀
        let imgItem = {
          'src': fileType !== 'pdf' && element.raw ? URL.createObjectURL(element.raw) : null, //预览图片的字段 前端用
          'raw': element.raw || null, //文件流
          'type': fileType, //文件类型 做区分用 不同类型预览方式不一样
          'name': element[this.prop.name], //文件名称 传给后端也是这个
          'key': element[this.prop.url] || '' //文件下载地址 传给后端也是这个
        }
        this.imgBlobList.push(imgItem)
        if (file[this.prop.prewKey] === element[this.prop.prewKey] && file[this.prop.name] === element[this.prop.name]) {
          this.index = i
          if (file.hasOwnProperty('raw')) { //有文件流 直接预览
            this.imgItem = imgItem
          } else { //否则 从服务器获取文件流
            this.imgItem = imgItem
            this.getFileBlob(file)
          }
        }
      })
    },
    // 预览接口
    async getFileBlob (file) {
      this.unLoad = false
      // let nameIndex = file[this.prop.name].split('.')
      // let type = nameIndex[nameIndex.length - 1]
      let subIndex = file[this.prop.name].lastIndexOf('.') + 1 // 查找文件后缀
      let fileType = file[this.prop.name].substring(subIndex).toLocaleLowerCase() // 获取文件后缀
      if (this.accept.indexOf(fileType) === -1) return //不支持的类型 不走接口
      let api = this.previewApi
      let key = file[this.prop.prewKey]
      let bucketName = ''
      // 对于切片上传的文件的预览地址的处理
      const array = [
        '::sunyur-test-isolation-file::',
        '::sunyurfile-isolation-shanghai::',
        '::sunyur-test-isolation-img::',
        '::sunyur-isolation-img::',
        '::public-img-isolation-shanghai::'
      ]
      for (let item of array) {
        if (key.indexOf(item) > -1) {
          key = key.split(item)[1]
          bucketName = item
          break
        }
      }
      let params = {
        key: key,
        ...this.previewExtraParams
      }
      if (bucketName) {
        params.extParam = {
          extBucketName: bucketName
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '文件加载中，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 使用axios接受文件流
      this.axios.post(api.url, params, {responseType: 'arraybuffer'})
        .then(async (response) => {
          loading.close()
          if (response.status === 200) {
            if (response.data.byteLength === 0) {
              this.unLoad = true
            } else {
              let blob = null
              if (this.watermarkText) { // 添加水印
                if (fileType === 'pdf') {
                  const pdfDoc = await PDFDocument.load(response.data)
                  // 加载内置字体
                  const fontBytes = await this.axios.get(`${window.fe.staticUrl}/fe-common/theme/1.0/font/pdf-lib/SourceHanSansCN-Regular.ttf`, {responseType: 'arraybuffer'})
                  // 自定义字体挂载
                  pdfDoc.registerFontkit(fontkit)
                  const customFont = await pdfDoc.embedFont(fontBytes.data)
                  // 获取文档所有页
                  const pages = pdfDoc.getPages()
                  const drawTextParams = {
                    lineHeight: 50,
                    font: customFont,
                    size: 12,
                    color: rgb(0.08, 0.08, 0.2),
                    rotate: degrees(15),
                    opacity: 0.3
                  }
                  for (let i = 0; i < pages.length; i++) {
                    const page = pages[i]
                    // 获取当前页宽高
                    const { width, height } = page.getSize()
                    // 要渲染的文字内容
                    for (let ix = 10; ix < width; ix += 180) { // 水印横向间隔
                      let lineNum = 0
                      for (let iy = 50; iy <= height; iy += 110) { // 水印纵向间隔
                        lineNum++
                        page.drawText(this.watermarkText, {
                          x: lineNum & 1 ? ix : ix + 60,
                          y: iy,
                          ...drawTextParams
                        })
                      }
                    }
                  }
                  const pdfBytes = await pdfDoc.save()
                  blob = new Blob([pdfBytes], { type: 'application/pdf' })
                } else {
                  blob = new Blob([response.data], { 'type': `image/${fileType}` })
                  const img = await this.blobToImg(blob)
                  const canvas = this.imgToCanvas(img)
                  blob = await this.imgWatermark(canvas)
                }
              } else {
                const blobType = (fileType === 'pdf' ? `application/pdf` : `image/${fileType}`)
                blob = new Blob([response.data], { 'type': blobType })
              }
              this.imgItem.src = window.URL.createObjectURL(blob) + (fileType === 'pdf' ? '#scrollbars=0&toolbar=0&statusbar=0' : '')
              this.imgBlobList[this.index].src = window.URL.createObjectURL(blob) + (fileType === 'pdf' ? '#scrollbars=0&toolbar=0&statusbar=0' : '')
              this.imgBlobList[this.index].raw = response.data
            }
          }
        })
        .catch((error) => {
          loading.close()
          console.log(error)
        })
    },
    // 图片鼠标拖拽事件
    handleMouseDown (e) {
      const { offsetX, offsetY } = this.transform
      const startX = e.pageX
      const startY = e.pageY
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX
        this.transform.offsetY = offsetY + ev.pageY - startY
      })
      on(document, 'mousemove', this._dragHandler)
      on(document, 'mouseup', ev => {
        off(document, 'mousemove', this._dragHandler)
      })
      e.preventDefault()
    },
    // 放大 缩小 旋转
    handleActions (action, options = {}) {
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      }
      const { transform } = this
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3))
          }
          break
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3))
          break
        case 'clocelise':
          transform.deg += rotateDeg
          break
        case 'anticlocelise':
          transform.deg -= rotateDeg
          break
      }
      transform.enableTransition = enableTransition
    },
    // 图片重置 style transform
    reset () {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    },
    // 重置当前显示的图片
    imgItemReset () {
      this.imgItem = {
        'src': null,
        'type': '',
        'name': '', //文件名称
        'raw': null,
        'key': ''
      }
    },
    // 全屏模式切换
    toggleMode () {
      const modeNames = Object.keys(Mode)
      const modeValues = Object.values(Mode)
      const index = modeValues.indexOf(this.mode)
      const nextIndex = (index + 1) % modeNames.length
      this.mode = Mode[modeNames[nextIndex]]
      this.reset()
    },
    // 图片加载失败
    handleImgError (e) {
      // this.loading = false
      e.target.alt = '加载失败'
    },
    // 切换 上一个
    prev () {
      if (this.imgBlobList.length === 1) return false
      this.imgItemReset()
      const len = this.imgBlobList.length
      this.index = (this.index - 1 + len) % len
      if (this.imgBlobList[this.index].src) {
        this.imgItem = this.imgBlobList[this.index]
      } else {
        this.imgItem = this.imgBlobList[this.index]
        this.getFileBlob(this.fileList[this.index])
      }
    },
    // 切换 下一个
    next () {
      if (this.imgBlobList.length === 1) return false
      this.imgItemReset()
      const len = this.imgBlobList.length
      this.index = (this.index + 1) % len
      if (this.imgBlobList[this.index].src) {
        this.imgItem = this.imgBlobList[this.index]
      } else {
        this.imgItem = this.imgBlobList[this.index]
        this.getFileBlob(this.fileList[this.index])
      }
    },
    // 点击下载按钮
    async downloadClick () {
      if (this.previewDownLoad) { //使用组件内的下载方法下载文件
        this.downloadAjax()
      } else { //将文件向外部抛出 满足个性化下载需求
        console.log('外部下载')
        this.$emit('downLoad', this.fileList[this.index])
      }
    },
    // 下载接口
    async downloadAjax () {
      let api = this.downloadApi
      let params = {
        'url': this.imgItem.key,
        'name': encodeURIComponent(this.imgItem.name)
      }
      download(api.type, api.url, params)
    },
    blobToImg (blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.addEventListener('load', () => {
          let img = new Image()
          img.src = reader.result
          img.addEventListener('load', () => resolve(img))
        })
        reader.readAsDataURL(blob)
      })
    },
    imgToCanvas (img) {
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      return canvas
    },
    imgWatermark (canvas) {
      return new Promise((resolve, reject) => {
        let ctx = canvas.getContext('2d')
        ctx.fillStyle = 'rgb(0.08, 0.08, 0.2)'
        ctx.globalAlpha = 0.3
        ctx.font = '14px microsoft yahei'
        ctx.rotate(Math.PI / 180 * -15)
        let lineNumX = 0 // X轴行号
        let lineNumY = 0 // Y轴行号
        let tempX = 0
        let targetX = 0 // 水印写入的X轴位置
        let targetY = 0 // 水印写入的Y轴位置
        for (let ix = 20; ix < canvas.width; ix += 180) { // 水印横向间隔
          lineNumX++
          lineNumY = 0
          for (let iy = 10; iy <= canvas.height; iy += 110) { // 水印纵向间隔
            lineNumY++
            tempX = lineNumY * 110 * Math.sin(Math.PI / 180 * 15) // 由于canvas被旋转，所以需要计算偏移量
            targetX = lineNumY & 1 ? ix - tempX : ix - tempX + 60
            targetY = iy + lineNumX * 180 * Math.tan(Math.PI / 180 * 15)
            ctx.fillText(this.watermarkText, targetX, targetY)
          }
        }
        canvas.toBlob(blob => resolve(blob))
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
    })
  },
  beforeDestroy () {
    const preview = document.querySelector('.sy-preview')
    if (preview) preview.remove()
  }
}
</script>
<style lang="scss" scoped>
  .sy-preview {
    z-index: 999999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    .mt-10 {
      margin-top: 10px;
    }
    .sy-image-viewer__mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: .5;
      background: #000;
      z-index: -1;
    }
    .el-icon-circle-close {
      font-size: 32px;
      position: absolute;
      top: 20px;
      right: 20px;
      color: #fff;
      cursor: pointer;
    }
    .el-icon-download {
      font-size: 32px;
      position: absolute;
      top: 20px;
      right: 72px;
      color: #fff;
      cursor: pointer;
    }
    .image-viewer__btn {
      position: absolute;
      z-index: 1;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      border-radius: 50%;
      opacity: .8;
      cursor: pointer;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    .image-viewer__next,
    .image-viewer__prev {
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      width: 44px;
      height: 44px;
      font-size: 24px;
      color: #fff;
      background-color: #606266;
      border-color: #fff;
    }
    .image-viewer__next {
      right: 40px;
      text-indent: 2px;
    }
    .image-viewer__prev {
      left: 40px;
    }
    .sy-image-viewer__canvas {
      width: 100%;
      height: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .sy-image-viewer__actions {
      left: 50%;
      bottom: 30px;
      transform: translateX(-50%);
      width: 282px;
      height: 44px;
      padding: 0 23px;
      background-color: #606266;
      border-color: #fff;
      border-radius: 22px;
    }
    .sy-image-viewer__actions__inner {
      width: 100%;
      height: 100%;
      text-align: justify;
      cursor: default;
      font-size: 23px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 72px;
      background-color: #000;
      line-height: 72px;
      z-index: 1;
    }
    .file-title {
      color: #fff;
      text-align: center;
      font-size:20px;
      padding: 0 100px;
    }
    .not-support__box {
      width: 100%;
      height: 100%;
    }
    .not-support__wapper{
      // width: 200px;
      background-color: #000;
      color: #fff;
      padding: 50px;
      text-align: center;
      border: 1px solid #000;
      border-radius: 4px;
      .link-box {
          width: 100px;
          height: 100px;
          display: inline-block;
          border: 2px solid #fff;
          border-radius: 10px;
        .el-icon-link {
          font-size: 100px;
        }
      }
      .text {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
